import * as React from 'react';
import { ImageInputAction, ImageInputActionType, ImageInputState, Sections } from './ImageInput.interface';

export const reducer: React.Reducer<ImageInputState, ImageInputAction> = (state, action) => {
    switch (action.type) {
        case ImageInputActionType.TOGGLE_MODAL:
            return { ...state, isModalOpen: action.payload, page: 0, search: '', resize: false };
        case ImageInputActionType.SET_SECTION:
            return { ...state, currentSection: action.payload, search: '' };
        case ImageInputActionType.SET_UPLOAD_LOADING:
            return {
                ...state,
                isUploadLoading: action.payload,
                page: 0,
                search: '',
                resize: false,
                currentSection: action.payload ? state.currentSection : Sections.Library,
            };
        case ImageInputActionType.NEXT_PAGE:
            return { ...state, page: state.page + 1 };
        case ImageInputActionType.SET_SEARCH:
            return { ...state, search: action.payload, page: 0 };
        case ImageInputActionType.SWITCH_RESIZE:
            return { ...state, resize: !state.resize };

        default:
            return state;
    }
};
